<template>
	<layout>
		<div class="container">
			<h2 class="title is-5">Ведутся работы по наполнению портала данными.</h2>			
			<p class="subtitle is-6">Попробуйте зайти на страницу позже.</p>
			<img src="../assets/svg/error-page.svg"/>
		</div>
	</layout>
</template>

<script>
	export default {
		props:{
			errorMessage: {
				type: String,
				required: true
			}
		},
		created() {
			window.console.error(this.errorMessage);
		}
	}
</script>
<style scoped>
	.container {
		text-align: center;
		padding-top: 40px;
	}

	.subtitle {
		padding: 45px 0px 15px 0px;
	}
</style>